import {
  DELETE_ADDRESS_FAILED,
  DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_INVALID_REQUEST,
  DELETE_ADDRESS_NOT_FOUND,
  LOADING_DELETE_ADDRESS,
  RESET_DELETE_ADDRESS,
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DELETE_ADDRESS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
      };

    case DELETE_ADDRESS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        status: "Failed to delete address, please try again!",
      };
    case DELETE_ADDRESS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        status: "Oops, something went wrong!",
      };

    case DELETE_ADDRESS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        status: "Address deleted sucessfully",
      };

    case RESET_DELETE_ADDRESS:
      return (state = initialState);

    default:
      return state;
  }
};
